module.exports = __webpack_public_path__ + "img/sgsbackground.ec7ac413.jpg";